import { z } from "zod";

export const DischargeLetterNeurosurgeryFormSchema = z.object({
  admission_findings: z.string().optional(),
  admission_medications: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  appointments: z.string().optional(),
  clinical_course: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  ecg: z.string().optional(),
  findings: z.string().optional(),
  further_diagnostic_findings: z.string().optional(),
  lab_results: z.string().optional(),
  laboratory_parameters: z.string().optional(),
  recommendations: z.string().optional(),
  social_anamnesis: z.string().optional(),
  therapy: z.string().optional(),
});
